// AccueilContent.js
import React from 'react';
import './AccueilContent.css';
import NosVehiculesContent from './NosVehiculesContent';
import Contact from './Contact.js';
import Slider from 'react-slick';
import { Helmet } from 'react-helmet-async';
import CarrouselVendu from './carrousselVendu.js';
import GoogleReviews from './GoogleReviews';

function AccueilContent({ navigateToVehicle }) {

  const imageUrls = [
    process.env.PUBLIC_URL + '/IMG_CLE.webp',
    process.env.PUBLIC_URL + '/IMG_6556.webp',
    process.env.PUBLIC_URL + '/IMG_6535.webp',
  ];

  const fallbackImageUrls = [
    process.env.PUBLIC_URL + '/IMG_CLE.png',
    process.env.PUBLIC_URL + '/IMG_6556.png',
    process.env.PUBLIC_URL + '/IMG_6535.png',
  ];

  const handleSlideImageError = (event, index) => {
    const img = event.currentTarget;
    const fallback = fallbackImageUrls[index];

    if (fallback && img.src !== fallback) {
      img.src = fallback;
      return;
    }

    img.src = process.env.PUBLIC_URL + '/M4.jpg';
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    easing: 'ease-in-out',
    swipeToSlide: true,
    pauseOnHover: false,
    draggable: false,
  };
  // Composants pour les flèches du slider


  return (
    <div className='accueil'>
      <Helmet>
        <title>FLIP MY CAR - ACHAT, VENTE ET REPRISE DE VÉHICULES D'OCCASION À CHAMBOURCY</title>
        <meta name="description" content="Achat, vente, reprise et recherche personnalisée de véhicules d'occasion de qualité à Chambourcy (78). Garantie premium, service complet." />
        <link rel="canonical" href="https://flipmycar.fr/" />
        <meta property="og:title" content="FLIP MY CAR - VÉHICULES D'OCCASION DE QUALITÉ" />
        <meta property="og:description" content="Achat, vente, reprise et recherche personnalisée de véhicules d'occasion à Chambourcy (78)." />
        <meta property="og:url" content="https://flipmycar.fr/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://flipmycar.fr/logo2.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="FLIP MY CAR - VÉHICULES D'OCCASION DE QUALITÉ" />
        <meta name="twitter:description" content="Achat, vente et reprise de véhicules d'occasion à Chambourcy (78)." />
        <meta name="twitter:image" content="https://flipmycar.fr/logo2.png" />
      </Helmet>
      <h1 className='banniere'> Achetez et vendez votre voiture avec <strong><em><span className="smaller-text">FLIP MY CAR</span></em></strong> </h1>
      <div className='banniereMobile'> Achetez et vendez votre voiture avec <strong><em><span className="smaller-text">FLIP MY CAR</span></em></strong> </div>
      <Slider {...settings} className='SliderBanniere' >
        {imageUrls.map((url, index) => (
          <div key={index} >
            <img
              className="slider-image"
              src={url}
              alt={`FLIP MY CAR - Showroom véhicules d'occasion ${index + 1}`}
              width={1920}
              height={737}
              fetchPriority={index === 0 ? "high" : "low"}
              onError={(event) => handleSlideImageError(event, index)}
            />
          </div>
        ))}
      </Slider>
      {/* Ajoutez ici le contenu spécifique à la section Accueil */}
      {/*<div className='formules'>
        <div onClick={() => changeSection('Reprise')} className='reprise'>
          <h1 className='titreforMobile'>Reprise</h1>
          <img src={process.env.PUBLIC_URL + '/reprise.png'} alt='reprise' className='logo'/>
          <h3 className='detail'>Nous nous chargeons de la vente de votre voiture au meilleur prix</h3>
          <button onClick={() => changeSection('Reprise')}  className='bouton'>Estimer mon véhicule</button>
        </div>
       <div onClick={() => changeSection('Nos véhicules')} className='dispo'>
          <h1 className='titreforMobile'>Véhicules disponibles</h1>
          <img src={process.env.PUBLIC_URL + '/vdispo.png'} alt='reprise' className='logo'/>
          <h3 className='detail'>Consultez notre selection de véhicules disponibles</h3>
          <button onClick={() => changeSection('Nos véhicules')} className='bouton'>Voir les véhicules</button>
          </div>
       <div onClick={() => changeSection('Recherches personnalisées')} className='recherche'>
          <h1 className='titreforMobile'>Recherche personnalisée</h1>
          <img src={process.env.PUBLIC_URL + '/search.png'} alt='reprise' className='logo'/>
          <h3 className='detail'>Nous trouverons selon vos critères votre prochaine voiture</h3>
          <button onClick={() => changeSection('Recherches personnalisées')}  className='bouton'>Accès au formulaire</button>
       </div>

       <div onClick={() => changeSection('Reprise')} className='repriseMobile'>
          <div className='repriseMobileTitre'>
            <h1 className='titreforMobile'>Reprise</h1>
            <img src={process.env.PUBLIC_URL + '/reprise.png'} alt='reprise' className='logoMobile'/>
          </div>
          <h3 className='detail'>Vendez votre voiture au meilleur prix</h3>
          <button onClick={() => changeSection('Reprise')}  className='bouton'>Estimer mon véhicule</button>
        </div>
       <div onClick={() => changeSection('Nos véhicules')} className='dispoMobile'>
       <div className='repriseMobileTitre'>
          <h1 className='titreforMobile'>Véhicules disponibles</h1>
          <img src={process.env.PUBLIC_URL + '/vdispo.png'} alt='reprise' className='logoMobile'/>
          </div>
          <h3 className='detail'>Notre sélection de véhicules disponibles</h3>
          <button onClick={() => changeSection('Nos véhicules')} className='bouton'>Voir les véhicules</button>
          </div>
       <div onClick={() => changeSection('Recherches personnalisées')} className='rechercheMobile'>
       <div className='repriseMobileTitre'>
          <h1 className='titreforMobile'>Recherche personnalisée</h1>
          <img src={process.env.PUBLIC_URL + '/searchmobile.png'} alt='reprise' className='logoMobile'/>
          </div>
          <h3 className='detail'>Nous trouverons votre prochaine voiture</h3>
          <button onClick={() => changeSection('Recherches personnalisées')}  className='bouton'>Accès au formulaire</button>
       </div>
      </div>*/}
      {/* <div className='complet'>
        <h1 className='titreforComplet'>Le service complet</h1>
        <img src={process.env.PUBLIC_URL + '/logo.svg'} alt='reprise' className='logoComplet'/>
      </div>
      <div className='completeDiv'>
      <div className='formz'>
        <h1 className='completeDivTitre' >Reprise</h1>
        </div>
        <img src={process.env.PUBLIC_URL + '/plus.svg'} alt='reprise' className='logoCompleteDiv'/>
        <div className='formz'>
        <h1 className='completeDivTitre' >Recherche personnalisée </h1>
        <h1 className='completeDivTitre ou' >ou </h1>
        <h1 className='completeDivTitre' >Véhicule disponible</h1>
        </div>
        
      </div> */}
      <div className='vehiculeDispo'>
        <NosVehiculesContent navigateToVehicle={navigateToVehicle} />
      </div>  
      
      <div className="points-forts-container">
        <h2 className="points-forts-title">POURQUOI NOUS<br/><span className="highlight-green">CHOISIR ?</span></h2>
        <div className="points-forts-grid">
          <div className="point-fort-card">
            <div className="point-fort-header">
              <div className="point-fort-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3 className="point-fort-title">Service complet</h3>
            </div>
            <p className="point-fort-desc">Reprise, véhicules disponibles ou recherche personnalisée, notre service complet répond à tous vos besoins automobiles.</p>
          </div>
          <div className="point-fort-card">
            <div className="point-fort-header">
              <div className="point-fort-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3 className="point-fort-title">Garantie premium</h3>
            </div>
            <p className="point-fort-desc">Tous nos véhicules bénéficient d'une garantie premium de 12 mois. Une extension jusqu'à 24 mois est possible.</p>
          </div>
          <div className="point-fort-card">
            <div className="point-fort-header">
              <div className="point-fort-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <h3 className="point-fort-title">Contrôle qualité</h3>
            </div>
            <p className="point-fort-desc">Nos véhicules sont soumis à un examen approfondi, assurant une qualité optimale et votre entière satisfaction.</p>
          </div>
          <div className="point-fort-card">
            <div className="point-fort-header">
              <div className="point-fort-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="1" y="3" width="15" height="13"></rect>
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                  <circle cx="5.5" cy="18.5" r="2.5"></circle>
                  <circle cx="18.5" cy="18.5" r="2.5"></circle>
                </svg>
              </div>
              <h3 className="point-fort-title">Livraison</h3>
            </div>
            <p className="point-fort-desc">Simplifiez votre achat avec notre service de livraison à domicile, partout en France.</p>
          </div>
          <div className="point-fort-card">
            <div className="point-fort-header">
              <div className="point-fort-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <h3 className="point-fort-title">Prix compétitifs</h3>
            </div>
            <p className="point-fort-desc">Nous vous proposons des véhicules de qualité à des prix compétitifs.</p>
          </div>
          <div className="point-fort-card">
            <div className="point-fort-header">
              <div className="point-fort-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <h3 className="point-fort-title">Service client</h3>
            </div>
            <p className="point-fort-desc">Notre équipe est là pour vous. Accompagnement, démarches simplifiées, service après-vente assuré.</p>
          </div>
        </div>
      </div>

      <GoogleReviews />

      <Contact/>
    <CarrouselVendu/>
    {/* <div className='complet'>
        <h1 className='titreforComplet'>Notre engagement</h1>
        </div> 
        <div className="ColFooterEngagement">
          <div className="ColFooterEngagementDesc"> 
            <h3>Nous nous engageons à vous offrir une expérience automobile de qualité. Avec des véhicules expertisés, un service client dédié, et des garanties étendues, nous mettons tout en œuvre pour vous assurer confiance et satisfaction à chaque étape de votre parcours avec nous.</h3>
            <br></br>
            <h3>Chez FLIP MY CAR, votre satisfaction est notre priorité.</h3>
          </div>
          <div>
            <img src={process.env.PUBLIC_URL + '/megane4.png'} className="Megane4" alt='Megane4'/>
          </div>
    </div> */}
  </div>
  );
}

export default AccueilContent;
